'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsonImmutableEx = require('json-immutable-ex');

var _immutable = require('immutable');

var _reduxTunnel = require('@wh/redux-tunnel');

var getState = function getState(state) {
    return state || (0, _immutable.Map)();
};

/**
 * Deserializes the passed state. If a string is passed then it gets JSON parsed. If isImmutable is true Immutable
 * records will be kept
 * @param {String|Object} [state] The state to be deserialized
 * @returns {Object} The deserialized state
 * @private
 */

var deserializeState = function deserializeState(state) {
    var immutableState = void 0;
    if (typeof state === 'string') {
        immutableState = (0, _jsonImmutableEx.deserialize)(state, { parseUnknownRecords: true });
    } else {
        immutableState = getState(state);
    }

    if (!immutableState.get('tunnel')) {
        return immutableState.set('tunnel', _reduxTunnel.defaultTunnel);
    }

    return immutableState;
};

exports.default = deserializeState;
//# sourceMappingURL=deserializeState.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/site-base-app-container/dist/main/deserializeState.js
// module id = 533
// module chunks = 0